
class addResumeReq {
	public phone: string;
	public captcha: string;
	public newPassword: string;
	public passwordAgain: string;


	constructor() {
		this.phone = '';
		this.captcha = '';
		this.newPassword = '';
		this.passwordAgain = '';
	}
} 


export {
	addResumeReq,

}